module.exports = __webpack_public_path__ + "media/background_7.ead644c8.mp4";